import header from "./immobilie-Raum-360-grad-bett.webp";
import section1 from "./house-in-a-box.webp";
import section2 from "./virtual-house-side-view.png";
import section3 from "./virtual-house.png";
import section4 from "./house-open-sideview.png";
import section5 from "./mensch-smartphone-haus-fotografie.webp";

export { header, section1, section2, section3, section4, section5 };
